export enum MiscellaneousDetails {
    WasherDryer = 2570,
    SponsorApartment = 2573,
    DiningRoom = 2571,
    EatInKitchen = 2581,
    MaidsRoom = 2572,
    SalesBuildingAllowsPets = 175,
    RentalsBuildingAllowsPets = 3781,
    LoftSpace = 3614,
    Penthouse = 3618,
    Fireplace = 3845
}